module.exports = __webpack_public_path__ + "static/media/youtube.d3aad347.svg";